// @ts-nocheck
import React from 'react';
import CommonForm from '../../../../components/hoc/common/handbook/CommonForm';
import Grid, { GridItem } from '../../../../components/layout/Grid';
import { FormField } from '../../../../components/Form';
import { Input } from 'antd';
export default props => {
  return <CommonForm {...props}>
      {({
      setFieldValue,
      values
    }) => {
      return <>
            <Grid gutter="16px">
              <GridItem>
                <FormField label="Наименование темы" fast required name="name">
                  {({
                name,
                value
              }) => <Input name={name} value={value} onChange={e => setFieldValue(name, e.target.value)} />}
                </FormField>
              </GridItem>
            </Grid>
          </>;
    }}
    </CommonForm>;
};
